var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"display-line"},[_c('div',[_c('div',{staticClass:"display-line-circle"},[_vm._v(" "+_vm._s(_vm.index)+" ")])]),_c('div',{staticClass:"display-line-intro"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }